/* Restore source-theme sticky scrolling when Shopify adds a legacy section wrapper. */
(function () {
  function repairStickyHeader() {
    var sticky = document.querySelector('sticky-header[data-sticky-type]');
    if (!sticky) return;
    var content = sticky.parentElement;
    var outer = content && content.parentElement;
    if (!outer || !outer.classList.contains('shopify-section')) return;
    content.classList.remove('section-header');
    outer.classList.add('section-header');
    sticky.header = outer;
    var rect = outer.getBoundingClientRect();
    sticky.headerBounds = { top: rect.top, bottom: rect.bottom };
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', repairStickyHeader);
  } else {
    repairStickyHeader();
  }
})();
